import { baseQuerySetup,transformResponse, onQueryStarted, onCacheEntryAdded } from 'config/index';
import { createApi } from '@reduxjs/toolkit/query/react';

let OpenReducer = 'OpenReducer';
let OpenTag = 'OpenTag';

export const openApi = createApi({
    reducerPath: OpenReducer,
    baseQuery: baseQuerySetup,
    tagTypes: [OpenTag],
    endpoints: (builder) => ({
        getUserTypes: builder.query({
            query: () => {
                return { url: 'login', method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse
        }),
        getDaystoClose: builder.query({
            query: () => {
                return { url: process.env.REACT_APP_BASE_URL.replace('admin', '') + 'marketplace/scenario/closing-categories', method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: (response) => {
                if (response?.statusCode === 200 || response?.statusCode === 201) {
                    return [{ label: 'select', value: '', disabled: true }, ...response.result.data];
                }
                return response;
            }
        })

    })
});

export const { useGetCompanyLendersQuery, useGetDaystoCloseQuery } = openApi;
